import { ad, jg, mid, sup, top } from "../assets";

const game = {
  line: [
    {
      img: top,
      key: "top",
      alt: " 탑 이미지",
    },
    {
      img: jg,
      key: "jg",
      alt: " 정글 이미지",
    },
    {
      img: mid,
      key: "mid",
      alt: " 미드 이미지",
    },
    {
      img: ad,
      key: "ad",
      alt: " 원딜 이미지",
    },
    {
      img: sup,
      key: "sup",
      alt: " 서포터 이미지",
    },
  ],
};

export default game;
